module.exports = __webpack_public_path__ + "static/media/book.32ce15f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/store/designer/book.jpg
// module id = 208
// module chunks = 0